import { useDateTime } from '@/hooks/useDateTime'
import { useUnits } from '@/hooks/useUnits'
import { DATA_PAGINATION } from '@/types'
import { Historical } from '@/types/historical'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface EtReferenceTableProps {
  data?: DATA_PAGINATION<Historical>
}

const EtReferenceTable: FC<EtReferenceTableProps> = ({ data }) => {
  const { formatDateByTimezone } = useDateTime()
  const { convertLabelUnit, convertFromMetric } = useUnits()

  return (
    <Stack flexGrow="1" justifyContent="space-between">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  width: '29px',
                  position: 'sticky',
                  left: 0,
                }}
              >
                #
              </TableCell>
              <TableCell
                sx={{
                  width: '182px',
                  boxShadow: 'inset -1px 0px 0px #D7D7D7',
                  position: 'sticky',
                  left: 0,
                }}
              >
                Description
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                Jan
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                Feb
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                Mar
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                Apr
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                May
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                Jun
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                Jul
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                Aug
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                Sep
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                Oct
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                }}
              >
                Nov
              </TableCell>
              <TableCell
                sx={{
                  width: '62px',
                  borderRight: '1px solid #D7D7D7',
                }}
              >
                Dec
              </TableCell>
              <TableCell
                sx={{
                  width: '196.5px',
                }}
              >
                Remote ET per day ({convertLabelUnit('mm')})
              </TableCell>
              <TableCell
                sx={{
                  width: '196.5px',
                }}
              >
                Remote ET valid to
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.data?.map((row) => (
              <TableRow key={Number(row.id)}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ position: 'sticky', left: 0 }}
                >
                  {Number(row.id)}
                </TableCell>
                <TableCell
                  sx={{
                    width: '182px',
                    boxShadow: 'inset -1px 0px 0px #D7D7D7',
                    position: 'sticky',
                    left: 0,
                  }}
                >
                  {row.description}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.january, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.february, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.march, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.april, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.may, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.june, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.july, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.august, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.september, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.october, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {Number(row.id) === 1
                    ? convertFromMetric(row.november, 'mm')
                    : '-'}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                  }}
                >
                  {Number(row.id) === 1
                    ? convertFromMetric(row.december, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {row.isUsed
                    ? convertFromMetric(row?.remoteETperDay, 'mm')
                    : '-'}
                </TableCell>
                <TableCell>
                  {formatDateByTimezone(row?.remoteETValidTo)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default EtReferenceTable
